import * as React from "react";
import { Button as AntButton, Col, Flex, Input, message, Row, Table } from "antd";
import AuthService from "../../Components/auth/AuthService";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import FormGrid from "../../Components/common/FormGrid";
import { ColumnHeightOutlined, NumberOutlined, TagsOutlined } from "@ant-design/icons";
import { decodeId } from "../../Components/common/CommonFun";

const Auth = new AuthService();

export default function Aisle(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const decodedID = decodeId(params?.id)

  var layoutDispatch = useLoadingDispatch();
  const { type: roleType, roles } = useSelector((state) => state?.AppState?.userCreds);


  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [aisleDetails, setAisleDetails] = React.useState({
    title: '',
    level: '',
    depth: '',
    location: ''
  });
  const [aisleLocations, setAisleLocations] = React.useState([]);

  const canAccess =
    roleType === 0 ||
    roleType === 1 ||
    (roleType === 2 && roles?.some((role) => role.role_id === 4));

  const getDataByID = async () => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/aisle/aisle?id=${id}`)
      if (res?.ack) {
        setAisleDetails({
          ...aisleDetails,
          title: res?.aisle?.title,
          level: res?.aisle?.levels,
          depth: res?.aisle?.depth,
          location: res?.aisle?.total_locations,
        });
        setAisleLocations(res?.aisle_locations || []);

      } else {
        showMessage("error", res?.message);
      }

    } catch (err) {
      console.log(err);
    }
    finally {
      hideLoading(layoutDispatch);
    }
  }
  React.useEffect(() => {
    if (id > 0) {
      getDataByID()
    }

  }, []);

  const onClickCancel = () => {
    navigate("/aisles");
  };

  const getAllAisles = async () => {
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/aisle/aisles`);
      if (res.ack) {
        if (res?.aisles.length > 0) {
          const newTimestamp = new Date().getTime();
          dispatch({
            type: 'SET_AISLE',
            payload: { aisles: res?.aisles, timestamp: newTimestamp },
          });
        }
      } else {
        showMessage("error", res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage("error", "Something went wrong ");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleSubmit = async () => {

    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    const validations = [
      { key: 'title', message: 'Please add title' },
      { key: 'level', message: 'Please add level' },
      { key: 'depth', message: 'Please add depth' },
      { key: 'location', message: 'Please add location' },
    ];

    for (const { key, message: errorMessage } of validations) {
      if (isEmptyOrUndefined(aisleDetails?.[key])) {
        showMessage("error", errorMessage);
        return;
      }
    }
    showLoading(layoutDispatch);
    const isUpdate = id > 0;
    const dataToSend = {
      id: isUpdate ? id : undefined,
      title: aisleDetails?.title,
      levels: aisleDetails?.level,
      depth: aisleDetails?.depth,
      total_locations: aisleDetails?.location,
    }
    try {
      const method = isUpdate ? "PUT" : "POST";
      const res = await Auth.fetch("/aisle/aisle", {
        method: method,
        body: JSON.stringify(dataToSend),
      })
      if (res?.ack) {
        getAllAisles();
        showMessage("success", res?.message);
        navigate('/aisles')
      } else {
        showMessage("error", res?.message);
      }

    } catch (err) {
      console.log(err);
    }
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const dataCol = [

    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },

    {
      title: 'Pallets',
      dataIndex: 'pallet_capacity',
      key: 'pallet_capacity',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Height',
      dataIndex: 'height',
      key: 'height',
    },
    {
      title: 'Width',
      dataIndex: 'width',
      key: 'width',
    }

  ];

  const formItems = [
    {
      label: "Title",
      value: aisleDetails?.title,
      onChange: (val) => setAisleDetails({ ...aisleDetails, title: val }),
      readOnly: false,
      icon: <TagsOutlined style={{ color: "#1677ff" }} />,
      type: 'text'
    },
    {
      label: "Levels",
      value: aisleDetails?.level,
      onChange: (val) => {
        if (val < 0) return showMessage('error', 'levels can not be negative!')
        setAisleDetails({ ...aisleDetails, level: val })
      },
      readOnly: false,
      icon: <NumberOutlined style={{ color: "#52c41a" }} />,
      type: 'number'
    },
    {
      label: "Depth (Pallets)",
      value: aisleDetails?.depth,
      onChange: (val) => {
        if (val < 0) return showMessage('error', 'Depth can not be negative!')
        setAisleDetails({ ...aisleDetails, depth: val })
      },
      readOnly: false,
      icon: <ColumnHeightOutlined style={{ color: "#faad14" }} />,
      type: 'number',
    },
    {
      label: "Number of Locations",
      value: aisleDetails?.location,
      onChange: (val) => {
        if (val < 0) return showMessage('error', 'Number of locations can not be negative!')
        setAisleDetails({ ...aisleDetails, location: val })
      },
      readOnly: false,
      icon: <NumberOutlined style={{ color: "#52c41a" }} />,
      type: 'number',
    },
  ]

  return (
    <>
      <h1> {id > 0 ? "Update" : "Add"} Aisle</h1>
      <FormGrid formItems={formItems} viewType='Page' />
      <Flex justify="end" gap={5} style={{ marginTop: "40px" }}>
        <AntButton
          onClick={onClickCancel}
        >
          Cancel
        </AntButton>
        {
          canAccess && (
            <AntButton type="primary" onClick={handleSubmit}>
              Save
            </AntButton>
          )}

      </Flex>
      <>
        {id > 0 && (
          <Table
            style={{ marginTop: "20px" }}
            title={() => <h3 style={{ margin: 2 }}>Aisle Locations</h3>}
            dataSource={aisleLocations}
            columns={dataCol}
            pagination={false}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          />
        )}
      </>
    </>
  );
}
